import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
// import reportWebVitals from './reportWebVitals';
import { Provider } from "react-redux";
import { store } from "./app/store";
import { BrowserRouter } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import { initSentry } from "./app/utils/sentry";
import { installOpsConsoleLogger } from "./app/utils/opsLogger";
import OpsErrorBoundary from "./app/components/utils/OpsErrorBoundary";
import { OperationFeedbackHost } from "./app/operationFeedback";

initSentry();
installOpsConsoleLogger();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  // <React.StrictMode>
  <OpsErrorBoundary>
    <Provider store={store}>
      <BrowserRouter>
        <App />
        <OperationFeedbackHost />
        <Toaster
          position="top-center"
          toastOptions={{ duration: 8000 }}
          containerStyle={{ zIndex: 2200 }}
        />
      </BrowserRouter>
    </Provider>
  </OpsErrorBoundary>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
